import {useState, useEffect} from "react";
import {useParams} from "react-router-dom";
import {useNavigateWithReload} from "base/hooks";

import {AuthAction, useAuth} from "base/auth";
import {PageLayout} from "base/layout";
import {useList} from "base/provider";
import {
    EntityTable,
    EntityFilterForm,
    EntityCreateButton,
    EntityChangeView,
    EntityListMap,
} from "base/entity";
import {PaperContainer} from "base/component/presentational";

import Grid from "@mui/material/Grid";

const EntityListPage = ({
    views = ["table", "map"],
    entityName,
    service,
    tableColumns,
    mapLayer = null,
    filterForm = null,
    createButton = true,
    elementActions = null,
    deleteAction = false,
    subPage = true,
}) => {
    const {ROLES} = useAuth();
    const navigate = useNavigateWithReload();
    const {idInfoPanel} = useParams();

    const {view, filter} = useList();

    const [selectedElement, setSelectedElement] = useState(null);

    const handleSelectElement = elementId => {
        setSelectedElement(elementId);
        navigate(`info/${elementId}`);
    };

    useEffect(() => {
        // If the sidebar panel is open we must highlight the element
        setSelectedElement(idInfoPanel ? parseInt(idInfoPanel) : null);
    }, [idInfoPanel]);

    const getViewComponent = () => {
        if (view === "table") {
            return (
                <EntityTable
                    columns={tableColumns}
                    service={service}
                    selectedElement={selectedElement}
                    onSelectElement={handleSelectElement}
                    elementActions={elementActions}
                    deleteAction={deleteAction}
                />
            );
        }
        if (view === "map") {
            return (
                <EntityListMap
                    layer={mapLayer}
                    service={service}
                    selectedElement={selectedElement}
                    onSelectElement={handleSelectElement}
                />
            );
        }
        return null;
    };

    return (
        filter && (
            <PageLayout subPage={subPage}>
                <PaperContainer justifyContent="space-between" alignItems="center">
                    <Grid
                        item
                        container
                        spacing={2}
                        justifyContent="flex-start"
                        alignItems="flex-start"
                    >
                        <Grid item container xs={8}>
                            {filterForm || <EntityFilterForm entityName={entityName} />}
                        </Grid>
                        <Grid
                            item
                            xs={4}
                            container
                            spacing={2}
                            justifyContent="flex-end"
                            alignItems="flex-start"
                        >
                            {createButton ? (
                                <Grid item>
                                    <AuthAction roles={[]}>
                                        <EntityCreateButton />
                                    </AuthAction>
                                </Grid>
                            ) : null}
                            {views.length > 1 ? (
                                <Grid item xs={1}>
                                    <EntityChangeView views={views} />
                                </Grid>
                            ) : null}
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sx={{mt: 3}}>
                        {getViewComponent()}
                    </Grid>
                </PaperContainer>
            </PageLayout>
        )
    );
};
export default EntityListPage;
